/**
 * SPEC-20260507-2100: wrappers REST pra logs de invocação IA.
 * RBAC: backend exige `platform-master`.
 */

import { apiFetch } from "./auth";

interface ApiSuccess<T> {
  success: true;
  data: T;
}

export type AIInvocationStatus = "pending" | "success" | "failed";

export type IntegrationKind =
  | "chat-stateless"
  | "chat-session"
  | "generate-script"
  | "validate-script"
  | "generate-script-interactive"
  | "credential-test"
  | "tool-loop-iteration"
  | "saga-variable-autofill"
  | "other";

export interface AIInvocationLogRow {
  id: string;
  integrationKind: IntegrationKind | string;
  provider: string;
  model: string;
  status: AIInvocationStatus;
  errorMessage: string | null;
  errorClass: string | null;
  sessionId: string | null;
  messageId: string | null;
  parentInvocationId: string | null;
  actorSub: string | null;
  actorUsername: string | null;
  systemPrompt: string | null;
  userPrompt: string | null;
  requestPayload: unknown;
  responsePayload: unknown;
  responseText: string | null;
  thinkingContent: string | null;
  toolsAvailable: unknown;
  toolsRequested: unknown;
  toolResults: unknown;
  inputTokens: number | null;
  outputTokens: number | null;
  thinkingTokens: number | null;
  durationMs: number | null;
  iteration: number;
  startedAt: string;
  finishedAt: string | null;
  createdAt: string;
}

export interface AIInvocationLogListResponse {
  data: AIInvocationLogRow[];
  pagination: { total: number; limit: number; offset: number };
}

export interface AIInvocationLogFilters {
  provider?: string;
  model?: string;
  status?: AIInvocationStatus;
  integrationKind?: string;
  actorSub?: string;
  sessionId?: string;
  dateFrom?: string;
  dateTo?: string;
  limit?: number;
  offset?: number;
}

function buildQs(filters: AIInvocationLogFilters): string {
  const sp = new URLSearchParams();
  for (const [k, v] of Object.entries(filters)) {
    if (v !== undefined && v !== null && v !== "") sp.set(k, String(v));
  }
  const s = sp.toString();
  return s ? `?${s}` : "";
}

export async function listAIInvocations(
  filters: AIInvocationLogFilters = {},
): Promise<AIInvocationLogListResponse> {
  const r = await apiFetch<ApiSuccess<AIInvocationLogListResponse>>(
    `/api/admin/ai-invocations${buildQs(filters)}`,
  );
  return r.data;
}

export async function getAIInvocation(id: string): Promise<AIInvocationLogRow> {
  const r = await apiFetch<ApiSuccess<AIInvocationLogRow>>(
    `/api/admin/ai-invocations/${encodeURIComponent(id)}`,
  );
  return r.data;
}
